const NotFound = () => {
  return (
    <div className="mx-auto py-5 sm:px-6 lg:px-8">
      Sorry, You Are Not Allowed to Access This Page.
    </div>
  );
};

export default NotFound;
